// Class names consumed by react-remove-scroll-bar when Radix locks body scroll.
export const SCROLL_LOCK_FULL_WIDTH_CLASS = "width-before-scroll-bar";
export const SCROLL_LOCK_FIXED_RIGHT_CLASS = "right-scroll-bar-position";
export const SCROLL_LOCK_VIEWPORT_WIDTH_CLASS = "scroll-lock-viewport-width";
export const SCROLL_LOCK_VIEWPORT_RIGHT_CLASS = "scroll-lock-viewport-right";
